import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, OnDestroy } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { IResponse } from '../../models/iresponse';
import { Brands } from '../../models/brands';
import { BrandCategories } from '../../models/brandCategories';

@Injectable({
  providedIn: 'root'
})
export class BrandsService {

  API_URLAddBrands  = `${environment.apiUrl}/Brand/AddUpdateBrand`;
  API_URLDeleteBrands  = `${environment.apiUrl}/Brand/DeleteBrand`;
  API_URLGetBrands = `${environment.apiUrl}/Brand/GetBrands`;
  API_URLGetBrand = `${environment.apiUrl}/Brand/GetBrand`;
  API_URLGetCategories = `${environment.apiUrl}/Category/GetCategories`;
  API_URLGetBrandByCategoryId= `${environment.apiUrl}/Brand/GetBrandByCategoryId`;
  API_URLAddUpdateCategoriesToBrand = `${environment.apiUrl}/Brand/AddUpdateCategoriesToBrand`;
  API_URLGetBrandCategories = `${environment.apiUrl}/Brand/GetBrandCategories`;
  API_URLDeleteBrandCategory = `${environment.apiUrl}/Brand/DeleteBrandCategory`;

  
  constructor(private http:HttpClient) {
  }


  GetBrandByCategoryId(categoryId:string): Observable<IResponse<Brands>> {
    const url = this.API_URLGetBrandByCategoryId;
    //Http request-
    return this.http.get<IResponse<Brands>>(url+`?categoryId=${categoryId}`)
  }

  GetBrands(): Observable<IResponse<Brands>> {
    const url = this.API_URLGetBrands;
    //Http request-
    return this.http.get<IResponse<Brands>>(url);
  }

  GetBrand(id:string): Observable<any> {
    const url = this.API_URLGetBrand;
    //Http request-
    return this.http.get<any>(url+`?id=${id}`)
  }
  
  Add(param: any): Observable<any> {
    const url = this.API_URLAddBrands;
    //Http request-
    return this.http.post(url,param);
  }
  
  DeleteBrand(id: any): Observable<any> {
    const url = this.API_URLDeleteBrands;
   
    // let param = {};
    return this.http.delete(`${url}?id=${id}`);

    //return this.http.post(url,param);
  }
  
  AddUpdateCategoriesToBrand(param: any): Observable<any> {
    const url = this.API_URLAddUpdateCategoriesToBrand;
    return this.http.post(url, param);
  }

  DeleteBrandCategory(brandCategoryId:string): Observable<any> {
    const url = this.API_URLDeleteBrandCategory;
    let param = {id: brandCategoryId};
    return this.http.delete(url, {params: param});
  }

  GetBrandCategories(id: string): Observable<IResponse<BrandCategories>> {
    const url = this.API_URLGetBrandCategories;
    return this.http.get<IResponse<BrandCategories>>(url+`?id=${id}`);
  }

}
